import React from 'react';
import { style } from '../../api';
import Flex from './Flex';
import Box from './Box';
import { Check } from './Icons';

interface Item<T> {
  value: T;
  label: React.ReactNode;
}

interface SelectListProps<T> {
  options: Item<T>[];
  selected?: T[];
  onChange: (selected: T[]) => void;
}

type Props<T extends string | number> = SelectListProps<T> &
  React.ComponentProps<typeof Flex>;

const MultiSelectList = ({
  options,
  selected,
  onChange,
}: Props<string | number>) => {
  const toggleItem = (value: string | number) => {
    if (selected && selected.includes(value)) {
      const filtered = selected
        ? selected.filter((item) => item !== value)
        : [];
      onChange(filtered);
    } else {
      onChange([...(selected || []), value]);
    }
  };
  return (
    <Flex width="100%" height="100%" flexDirection="column">
      {options.map(({ label, value }) => (
        <Flex
          key={value}
          alignItems="center"
          justifyContent="space-between"
          py={3}
          onClick={() => toggleItem(value)}
          opacity={selected && selected.includes(value) ? 1 : 0.65}
          fontWeight={selected && selected.includes(value) ? 'bold' : 'initial'}
        >
          {label}

          <Box color={style.primary_pink_new} size="18px">
            {Boolean(selected && selected.includes(value)) && (
              <Check size={18} />
            )}
          </Box>
        </Flex>
      ))}
    </Flex>
  );
};

export default MultiSelectList;
